import { supabase } from '../services/supabaseClient';
import { logAuditEvent, type AuditEventParams } from '../services/AuditService';

/**
 * Registra un evento de auditoría con el usuario de la sesión actual como actor
 * (fallback: firmId, porque firmId = auth.users.id). Para servicios que no
 * reciben userId. Fire-and-forget: nunca lanza (igual que logAuditEvent).
 */
export async function auditAsCurrentUser(firmId: string, params: AuditEventParams): Promise<void> {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    const userId = session?.user?.id ?? firmId;
    await logAuditEvent(supabase, firmId, userId, params);
  } catch (err) {
    console.warn('[auditAsCurrentUser] audit failed — primary operation unaffected:', err);
  }
}
